import { useEffect, useRef } from 'react';

type IyzicoCheckoutFormProps = {
  checkoutFormContent: string;
};

/**
 * iyzico Checkout Form HTML içeriğini sayfaya gömer.
 * iyzico yanıtındaki script etiketleri ayrıca çalıştırılır.
 */
export default function IyzicoCheckoutForm({ checkoutFormContent }: IyzicoCheckoutFormProps) {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    container.innerHTML = checkoutFormContent;

    container.querySelectorAll('script').forEach((oldScript) => {
      const script = document.createElement('script');
      for (const attr of oldScript.attributes) {
        script.setAttribute(attr.name, attr.value);
      }
      script.textContent = oldScript.textContent;
      oldScript.replaceWith(script);
    });
  }, [checkoutFormContent]);

  return (
    <div className="iyzico-checkout">
      <div ref={containerRef} className="iyzico-checkout-form" />
    </div>
  );
}
